import { NORTH_AMERICAN_PHONE_ERROR, NORTH_AMERICAN_PHONE_REGEX } from 'constants/phoneNumbers';

export const normalizeNorthAmericanPhone = (phone?: string | null) => {
  return phone?.trim() ?? '';
};

export const getNorthAmericanPhoneInputValue = (phone?: string | null) => {
  const digits = (phone ?? '').replace(/\D/g, '');
  const nationalNumber = digits.startsWith('1') ? digits.slice(1, 11) : digits.slice(0, 10);

  return nationalNumber ? `+1${nationalNumber}` : '';
};

export const formatNorthAmericanPhoneInput = (phone?: string | null) => {
  const canonicalPhone = getNorthAmericanPhoneInputValue(phone);
  if (!canonicalPhone) {
    return '';
  }

  const nationalNumber = canonicalPhone.slice(2);
  if (nationalNumber.length <= 3) {
    return `+1 (${nationalNumber}`;
  }
  if (nationalNumber.length <= 6) {
    return `+1 (${nationalNumber.slice(0, 3)}) ${nationalNumber.slice(3)}`;
  }

  return `+1 (${nationalNumber.slice(0, 3)}) ${nationalNumber.slice(3, 6)}-${nationalNumber.slice(6)}`;
};

export const isValidNorthAmericanPhone = (phone?: string | null) => {
  const normalizedPhone = normalizeNorthAmericanPhone(phone);
  return !normalizedPhone || NORTH_AMERICAN_PHONE_REGEX.test(normalizedPhone);
};

export const validateOptionalNorthAmericanPhone = (_: unknown, phone?: string | null) => {
  if (isValidNorthAmericanPhone(phone)) {
    return Promise.resolve();
  }

  return Promise.reject(new Error(NORTH_AMERICAN_PHONE_ERROR));
};
